import { useState } from 'react';
import { Card, Heading, Link, Stack, Tab, Tabs, Text } from '@99designs/emu';
import { FormattedReactMessage } from '@99designs/frontend-components/i18n';
import { howItWorksContent } from '../HowItWorks/howItWorksContent';
import { HowItWorksSteps } from '../HowItWorksSteps';
import type { CollaborationMethod } from '../../types';
import type { HowItWorksStep } from '../HowItWorksSteps';

export function HowItWorksTabbed() {
    const [activeTab, setActiveTab] = useState<CollaborationMethod>(
        'COLLABORATION_METHOD_ONE_TO_ONE_PROJECT'
    );
    const [howItWorksSteps, setHowItWorksSteps] = useState<HowItWorksStep[]>(
        howItWorksContent('COLLABORATION_METHOD_ONE_TO_ONE_PROJECT').steps
    );

    const handleTabClick = (tabId: CollaborationMethod) => {
        setActiveTab(tabId);
        setHowItWorksSteps(howItWorksContent(tabId).steps);
    };

    return (
        <Stack space="1bu">
            <Heading appearanceLevel={4} accessibilityLevel={2}>
                {__placeholder('How it works')}
            </Heading>

            <Text>
                {__placeholder(
                    "We've got two amazing ways to connect you with a professional designer that's right for you."
                )}
            </Text>

            <Card
                padding="2bu" /* appearance="filled" <-- once images have transparent backgrounds */
            >
                <Tabs aria-label="Secondary">
                    <Tab
                        active={activeTab === 'COLLABORATION_METHOD_ONE_TO_ONE_PROJECT'}
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            handleTabClick('COLLABORATION_METHOD_ONE_TO_ONE_PROJECT');
                        }}
                    >
                        {__placeholder('1-to-1 Project')}
                    </Tab>
                    <Tab
                        active={activeTab === 'COLLABORATION_METHOD_CONTEST'}
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            handleTabClick('COLLABORATION_METHOD_CONTEST');
                        }}
                    >
                        {__placeholder('Contest')}
                    </Tab>
                </Tabs>
                <HowItWorksSteps steps={howItWorksSteps} />
            </Card>

            <FormattedReactMessage
                message={__placeholder(
                    "If you're a bigger business looking for a more bespoke experience, <Link>get it touch with our Pro Studio team.</Link>"
                )}
                replacements={{
                    Link: <Link href="/pro/studio" />,
                }}
            />
        </Stack>
    );
}
